import { useNavigate } from 'react-router-dom'
import { Button } from '@mui/material'

import { MobileBottomLayout } from 'src/components/mobile-bottom-layout'

import useStyles from './styles'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IProps {
  isDisabled?: boolean
}

const MobileEditButtons = ({isDisabled}: IProps) => {
  const navigate = useNavigate()
  const classes = useStyles({})

  return (
    <MobileBottomLayout isFixed>
      <Button
        variant="contained"
        onClick={() => navigate('scan-history')}
        className={`${classes.formButton} ${classes.formButtonLight}`}
      >
        <HelperWrapper t="scan-history-view-button" />
      </Button>
      {!isDisabled &&
      <Button
        variant="contained"
        className={classes.formButton}
        onClick={() => navigate('qr-code')}
      >
        <HelperWrapper t="qr-code-view-button" />
      </Button>}
    </MobileBottomLayout>
  )
}

export { MobileEditButtons }
